import React, { useEffect, forwardRef } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import {ProductViewOnly} from "../ProductViewOnly";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ProductViewDialog({open, product, onClose}) {

    console.log('[ProductViewDialog]');

    useEffect(() => {
        console.log('ProductViewDialog');
    }, []);

    return (
        <Dialog fullScreen
                open={open}
                onClose={onClose}
                TransitionComponent={Transition}>
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    {/*<Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">*/}
                        {/*Sound*/}
                    {/*</Typography>*/}
                </Toolbar>
            </AppBar>
            <ProductViewOnly product={product} />
        </Dialog>
    )
};